import React, { Fragment } from 'react';

const ChargingCostSF = () => (
  <Fragment>
    <p>
      Pricing to use a Supercharger may vary by location. Specific pricing
      for each Supercharger location is shown on the popup of the selected
      pin on the navigation app on the vehicle touchscreen. Certain
      Supercharger stations offer on-peak and off-peak rates.
    </p>
    <br />
    <p>
      There are apps such as Plugshare and ChargePoint, which can help you
      find free or more cost-efficient charging stations in your area. Keep
      in mind that while some public charging stations are free, most
      require payment based on various factors like location, charging
      duration, or the number of kilowatt-hours used. Also, many Plugshare
      3rd party chargers are not compatible with Tesla vehicles and would
      require an additional adapter. Specifically, it is the J1772 adapter.
      It would need to be purchased separately for use with 3rd party
      chargers.
    </p>
    <br />
  </Fragment>
);

export default ChargingCostSF;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/DrivesharingPolicies/ChargeCost.js